<div class="loading" *ngIf="!loaded"></div>
<div *ngIf="loaded">
    <div class="top-header" *ngIf="this.type != 'add'">
      <div class="sm-12 item-middle">
        <div >
            <div class="head-one header_text">{{'Edit grades' | translate}}</div>
            <div class="sub_header_text">{{this.projectData?.name}}, {{this.projectData?.country?.name}}</div>
        </div>
      </div>
    </div>
</div> 

<div class="pre-white marT10 " *ngIf="loaded" [style.width]="this.type !== 'add'?'492px':'518px'" [ngClass]="this.type !== 'add'?'pad20':'pad30'">
    <div class="project-setup-header"  *ngIf="this.type == 'add'" >
        <div class="sm-12 item-middle">
            <div>
                <div class="head-one header_text"><label class="form-title">{{'Add grades' | translate}} </label> </div>
                <div class="sub_header_text"><label class="label-light">{{this.projectData?.name}}, {{this.projectData?.country?.name}}</label></div>
            </div>
        </div>
    </div>
    <div class="row">
        <label class="marT20 padR20 lineHgt15 labeltxt" *ngIf="this.type=='add'">{{'Add all grades' | translate}}</label>
        <label class="lineHgt15 labeltxt" *ngIf="this.type!='add'">{{'Add edit or remove grades' | translate }}</label>
    </div>
    <div class="white">
            <form class="form-inline" [formGroup]="this.myFormGroup" >
                <div class="row marB10 marT10 column lg-12 md-12 sm-12 flexStart">
                    <div class="" [style.width]="this.gradeState=='view' ? '220px' : '228px'"><label class="label-light">{{'Project grade names' | translate}}</label></div>
                    <div [ngClass]="textDir=='ltr'?'marL15':'marR15'" [style.width]="this.gradeState=='view' ? '138px' : '127px'"><label class="label-light">{{'Reference year' | translate}} <span _ngcontent-qmd-c83="" class="optional">*</span></label></div>
                </div>

                <div formArrayName="gradeArray" >
                    <!-- <div *ngFor="let gradeClass of this.myFormGroup.controls.gradeArray.controls; let i = index"> -->
                        <div *ngFor="let gradeClass of this.myFormGroup.get('gradeArray')['controls']; let i = index">    
                            <div class="row nomargin marT10 marB10" [formGroupName]="i" *ngIf="this.row[i]==true" >
                                
                                <div  >
                                    <!-- <p>test - {{gradeClass.value['grade_id']}} - formControlName</p> -->
                                    <input type="text" class="form-control" placeholder="(Enter grade name here)" [style.width]="this.gradeState=='view' ? '220px' : '228px'" formControlName="name" (input)="gradeChange($event)" [dir]="textDir">
                                </div>

                                <div class="" [style.width]="this.gradeState=='view' ? '138px' : '144px'" [ngClass]="textDir=='ltr'?'marL5':'marR5 rtl'">
                                    <ngx-select-dropdown [multiple]="false" formControlName="year" [options]="yearList" [config]="yearSelectConfig" (change)="modifyYearList($event);"></ngx-select-dropdown>
                                </div>

                                <div class="marL10">
                                        <div *ngFor="let gradecheck of mygradecheckArr;">
                    
                                            <div *ngIf="gradecheck._id == gradeClass.value['grade_id']  && ((i > 0) || i==11)">
                                                <a *ngIf="gradecheck.remove" (click)="removeGrade(i)" class="edit" >
                                                    <span class="dotted-txt">{{'Remove' | translate}}</span>
                                                </a>
                                                <a *ngIf="!gradecheck.remove" class="edit" style="cursor:default;opacity: 0.4;">
                                                    <span class="dotted-txt">{{'Remove' | translate}}</span>
                                                </a>
                                                
                                            </div>
                                        </div>

                                        <div *ngIf="gradeClass.value['grade_id'] == null" >
                                            <div style="margin:0px;font-size: 11px; color: #242424;">
                                                <a (click)="removeGrade(i)" class="edit">
                                                    <span class="dotted-txt">{{'Remove' | translate}}</span>
                                                </a>
                                            </div>
                                        </div>


                                </div>
                            </div>
                            <!-- <div class="nomargin add_btn" *ngIf="(this.row[i]==false && this.row[i-1]==true && this.finrow < i)">
                                <button type="button" class="btn btn-next" style="margin-left:2px;" (click)="addGrade(i)">Add another grade</button>
                            </div> -->
                        </div>

                    <div  class="nomargin padT10"  [ngClass]="this.gradeState=='setup'?'add_btn':'add_btn_left'"*ngIf="blankItemIndex == 0 && isEdited == 0">
                        <button type="button" class="btn btn-next" (click)="addGrade(blankItemIndex)">{{'Add new grade' | translate}}</button>
                    </div>
                    <div  class="nomargin padT10"  [ngClass]="this.gradeState=='setup'?'add_btn':'add_btn_left'"*ngIf="blankItemIndex == 0 && isEdited == 1">
                        <button type="button" class="btn btn-next primary" (click)="addGrade(blankItemIndex)" [disabled]="nextBtnDisabled">{{'Add a grade' | translate}}</button>
                    </div>
                    <div  class="nomargin padT10"  [ngClass]="this.gradeState=='setup'?'add_btn':'add_btn_left'"*ngIf="blankItemIndex >= 1 && blankItemIndex < 12">
                        <button type="button" class="btn btn-next primary" (click)="addGrade(blankItemIndex)" [disabled]="nextBtnDisabled" >{{'Add a grade' | translate}}</button>
                    </div>

                    <div *ngIf="this.gradeState=='view'" >
                        <div class="lineHgt15 flexStart marT15 marB20" >
                        <i class="icon icon-info info-txt  marT3" [ngClass]="textDir=='ltr'?'marR5':'marL5'"></i>
                        <div ><label class="info-txt" [dir]="textDir">{{'A Grade can only be removed' | translate}}</label></div>
                        </div>
                    </div>
                </div>

            </form>
    </div>
</div>
